export const FavoriteCandidateUtil = {
  isCandidateFavorited(candidate, favoritesData) {
    return favoritesData?.idMap?.[candidate.id] ?? false;
  },
};
